import { ON_MESSAGE_READING, ON_MESSAGE_READ } from './types';
import { notification } from 'antd';
import {
  addMessageApi,
  resolveMessageApi,
  getMessagesApi,
} from '../api/message';
import { getAccessTokenApi } from '../api/auth';

export const onMessageRead = () => async (dispatch) => {
  dispatch({ type: ON_MESSAGE_READING });
  let token = await getAccessTokenApi();
  return getMessagesApi(token).then(async (response) => {
    await dispatch({ type: ON_MESSAGE_READ, payload: response.messages });
  });
};

export const onMessageCreate =
  (messageData, setIsVisibleModal, type) => async (dispatch) => {
    let token = await getAccessTokenApi();

    return addMessageApi(messageData, token)
      .then(async (response) => {
        if (response?.code !== 200) {
          notification['error']({ message: response.message });
        } else {
          notification['success']({ message: response.message });
          window.location.hash !== '#/turns' &&
            (await dispatch(onMessageRead()));
          setIsVisibleModal(false);
        }
      })
      .catch(() => {
        notification['error']({
          message: 'Error del servidor, intente mas tarde.',
        });
      });
  };

export const onMessageResolve = (id) => async (dispatch) => {
  let token = await getAccessTokenApi();

  return resolveMessageApi(id, token)
    .then(async (response) => {
      if (response?.code !== 200) {
        notification['error']({ message: response.message });
      } else {
        notification['success']({ message: response.message });
        await dispatch(onMessageRead());
      }
    })
    .catch(() => {
      notification['error']({
        message: 'Error del servidor, intente mas tarde.',
      });
    });
};
